module.exports = __webpack_public_path__ + "media/images/bain bouillonnant-062839d43d00334dc8ff0906d27e977d.svg";